import { CommonModule } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AppIconComponent } from '@app/components/app-icon/app-icon.component';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationsService } from '@services/notifications.service';
import { PipesModule } from '@shared/pipes/pipes.module';
import { TimeagoModule } from 'ngx-timeago';
import { AvatarModule } from 'primeng/avatar';
import { Popover, PopoverModule } from 'primeng/popover';

/**
 * Notifications bell for the global header.
 *
 * Desktop/tablet render the list in an anchored popover.
 *
 * The list is empty until the notifications API exists; see
 * `NotificationsService` for the seam.
 */
@Component({
  selector: 'app-notifications-panel',
  templateUrl: './notifications-panel.component.html',
  styleUrls: ['./notifications-panel.component.scss'],
  standalone: true,
  imports: [CommonModule, AppIconComponent, AvatarModule, PipesModule, PopoverModule, TimeagoModule, TranslateModule],
})
export class NotificationsPanelComponent implements OnInit {
  @ViewChild('op') popover!: Popover;
  @ViewChild('panel') panel!: TemplateRef<unknown>;

  constructor(public readonly notificationsService: NotificationsService) {}

  public ngOnInit(): void {
    this.notificationsService.load().subscribe();
  }

  public toggle(event: Event): void {
    this.popover.toggle(event);
  }

  public markAllRead(): void {
    this.notificationsService.markAllRead();
  }
}
